import { z } from 'zod'

// A JSON-encoded `{ [key]: string }` query param, the object counterpart of `stringifiedArray`.
export const stringifiedRecord = z.coerce.string().transform((str, ctx): Record<string, string> => {
  try {
    const parsed = JSON.parse(str)
    const result = z.record(z.string(), z.string()).safeParse(parsed)

    if (result.success) return result.data
  } catch {
    // Falls through to the issue below.
  }

  ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Invalid record format' })
  return z.NEVER
})
